import React from 'react';
import "./visionmission.css";

function Visionmision() {
    return (
        <>
            <section className="vision-mission">
                <div className="container">
                    <div className="row p-1">
                        <div className="col-md-6  mt-5 ">
                            {/* <h4 className="text-white">Vision</h4> */}
                            <div class="section-title clearfix">
                                    <div class="title-header">
                                        <h5 style={{ textTransform: "uppercase", color:" #ffb703" }}>vission</h5>
                                        {/* <h3>NSPP IMPORTS/EXPORTS</h3> */}
                                        </div>
                                    <div className='underline'></div>
                                </div>
                            <p className='p-para text-white1'>
                         To be the most trusted career partner for IT & ITES professionals.

Bridge the gap between talent and opportunity with clarity.

Empower growth, adaptability, and success in a dynamic job market.

Foster continuous learning, inclusivity, and equal access to opportunities.

Build trust through transparent, reliable, and consistent guidance.

Partner with companies to nurture future-ready talent.

Enable individuals to navigate career transitions and reach their fullest potential.

Drive innovation, creativity, and problem-solving in career development.

Shape a stronger, future-proof workforce for the digital era.

Be a lifelong partner in every professional’s journey. </p>
                        
                        </div>
                        <div className="col-md-6  mt-5">
                        <div class="section-title clearfix">
                                    <div class="title-header">
                                        <h5 style={{ textTransform: "uppercase", color:" #ffb703" }}>mission</h5>
                                        {/* <h3>NSPP IMPORTS/EXPORTS</h3> */}
                                        </div>
                                    <div className='underline'></div>
                                </div>
                            <p className='p-para text-white1'>
Support individuals in achieving their professional goals with reliable job placement.

Provide personalized mentoring and direct access to top-tier IT & ITES employers.

Guide professionals at every stage of their careers through counseling and advice.

Offer continuous skill development opportunities to enhance employability.

Design tailored growth strategies aligned with individual aspirations and strengths.

Match professionals with roles that best reflect their true potential.

Collaborate with leading organizations to create meaningful career pathways.

Focus on both immediate job requirements and long-term career success.

Uphold trust, transparency, and innovation in all our practices.

Empower professionals with confidence, adaptability, and resilience in a changing job market.
</p>                        </div>
                    </div>
                </div>
            </section></>
    )
}

export default Visionmision
